// pages/testimonials/Testimonials.js
import React, { useEffect, useState } from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {
  Row,
  Col,
  Button,
  Container,
  Table,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTestimonialsAction,
  fetchSingleTestimonialAction,
  deleteTestimonialAction,
} from "./TestimonialAction";
import { TestimonialForm } from "../../components/testimonials/TestimonialForm";
import {
  selectTestimonials,
  selectSelectedTestimonial,
  selectIsLoading,
} from "./testimonialSelectors";

const Testimonials = () => {
  const dispatch = useDispatch();

  const testimonials = useSelector(selectTestimonials);
  console.log(testimonials);
  const selectedTestimonial = useSelector(selectSelectedTestimonial);
  const isLoading = useSelector(selectIsLoading);

  const [showForm, setShowForm] = useState(false);
  const [editTestimonialId, setEditTestimonialId] = useState(null);
  const [editInitial, setEditInitial] = useState(null);

  useEffect(() => {
    dispatch(fetchTestimonialsAction());
  }, [dispatch]);

  const handleEdit = (id) => {
    setEditTestimonialId(id);
    const existing = Array.isArray(testimonials)
      ? testimonials.find((t) => t._id === id)
      : null;
    setEditInitial(existing || null);
    dispatch(fetchSingleTestimonialAction(id)); // refresh in background
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      await dispatch(deleteTestimonialAction(id));
      dispatch(fetchTestimonialsAction()); // refresh list
    }
  };

  const handleAddNew = () => {
    setEditTestimonialId(null);
    setEditInitial(null);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditTestimonialId(null);
    setEditInitial(null);
  };

  return (
    <DefaultLayout>
      <Container>
        <Row className="py-2">
          <Col>
            <h5>Testimonials</h5>
            <div className="text-end">
              <Button variant="primary" onClick={handleAddNew}>
                Add New Testimonial
              </Button>
            </div>
            <hr />
          </Col>
        </Row>

        {isLoading && (
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <Row>
          <Col>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Category</th>
                  <th>title</th>
                  <th>Platform</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(testimonials) && testimonials.length > 0 ? (
                  testimonials.map((t) => (
                    <tr key={t._id}>
                      <td>{t.name}</td>
                      <td>{t.type}</td>
                      <td>{t.category}</td>
                      <td>{t.title ?? "-"}</td>
                      <td>{t.platform ?? "-"}</td>
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEdit(t._id)}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDelete(t._id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No testimonials found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>

        <Modal show={showForm} onHide={handleCloseForm} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {editTestimonialId ? "Edit Testimonial" : "Add New Testimonial"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TestimonialForm
              testimonialId={editTestimonialId}
              initialData={editInitial} // ⬅️ seed instantly
              selectedTestimonial={selectedTestimonial} // ⬅️ override when fetched
              onClose={() => {
                handleCloseForm();
                dispatch(fetchTestimonialsAction()); // refresh table after save
              }}
            />
          </Modal.Body>
        </Modal>
      </Container>
    </DefaultLayout>
  );
};

export default Testimonials;
